import { http } from "./config";
import authHeader from "./auth-header";

export default {
  gerar: (solicitacao) => {
    return http.post(
      "/assistant-agent/orquestrar",
      { solicitacao },
      {
        headers: authHeader(),
      }
    );
  },

  ultimas: (limite = 50) => {
    return http.get("/assistant-agent/ultimas", {
      params: { limite },
      headers: authHeader(),
    });
  },

  novoExportarExcel: (id) => {
    return http.get("/assistant-agent/novo-exportar-excel", {
      params: { id },
      responseType: "blob",
      headers: authHeader(),
    });
  },
};
